import React, { useEffect, useRef, useState } from 'react';
import { Button, Spin, Typography } from 'antd';
import FeedbackTemplateTable from './FeedbackTemplateTable';
import FeedbackTemplateAdd from './FeedbackTemplateAdd';
import {
  getFeedbackTemplates,
  updateFeedbackTemplate,
} from '../../services/feedbackService';

const { Title, Text } = Typography;

const FeedbackTemplate = ({ feedbackStatus }) => {
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [feedbackTemplateData, setFeedbackTemplateData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [status, setStatus] = useState({
    error: false,
    message: '',
  });

  useEffect(() => {
    setStatus({ error: false, message: 'LOADING' });
    getFeedbackTemplates()
      .then((response) => {
        const data = response?.data?.paginatedList.filter((template) => {
          if (feedbackStatus === 'active') {
            return !template.isArchived;
          } else {
            return template.isArchived;
          }
        });
        setFeedbackTemplateData(data);
        setTotalCount(data.length);
        setStatus({ error: false, message: 'SUCCESS' });
      })
      .catch((err) => {
        alert('Getting data from the backend failed!');
        setStatus({
          error: true,
          message: `${err}`,
        });
      });
  }, []);

  const archiveAndRemoveItem = (item, index) => {
    updateFeedbackTemplate(item._id, {
      isArchived: feedbackStatus === 'active',
    })
      .then((res) => {
        let newData = feedbackTemplateData;
        newData.splice(index, 1);
        newData = [...newData];
        setFeedbackTemplateData(newData);
        setTotalCount(newData.length);
      })
      .catch((err) => {
        alert(err);
      });
  };

  return (
    <>
      <div
        style={{
          paddingBottom: '40px',
        }}
      >
        <Text
          style={{
            float: 'left',
            position: 'relative',
          }}
        >
          Total Templates:{' '}
          <strong style={{ fontSize: '20px' }}>{totalCount}</strong> records
        </Text>
        {feedbackStatus === 'active' && (
          <Button
            style={{
              float: 'right',
              position: 'relative',
            }}
            onClick={() => {
              setIsAddModalVisible(true);
            }}
          >
            Add Feedback Template
          </Button>
        )}
      </div>

      {feedbackStatus === 'active' && (
        <FeedbackTemplateAdd
          isOpen={isAddModalVisible}
          toggle={() => setIsAddModalVisible(false)}
        />
      )}

      {status.error ? (
        <div style={{ marginTop: '50px', textAlign: 'center' }}>
          <Title>{status.message}</Title>
        </div>
      ) : status.message === 'LOADING' ? (
        <Spin />
      ) : (
        <FeedbackTemplateTable
          data={feedbackTemplateData}
          totalCount={totalCount}
          archiveItem={archiveAndRemoveItem}
          status={feedbackStatus}
        />
      )}
    </>
  );
};

export default FeedbackTemplate;
